import "./navbar.css";
import {
  Autorenew,
  InventoryOutlined,
  Menu,
  TrendingUp,
  AddShoppingCartOutlined,
  PlayCircleOutline,
  ShoppingCartCheckout,
  AddCardOutlined,
  PersonAddAltOutlined,
  GroupsOutlined,
  Close,
  ImportExport,
  ReceiptOutlined,
  DashboardCustomize,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import LogoutSharp from "@mui/icons-material/Logout";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logout } from "../../redux/login";
import { useDispatch } from "react-redux";
import { persistor } from "../../redux/store";
import { clearItems } from "../../redux/items";
import { clearSales } from "../../redux/sales";
import useRefresh from "../../utils/useRefresh";
import CheckOutDialog from "../CheckOutDialog";
import { resetCart } from "../../redux/cart";
import { clearExpenses } from "../../redux/expenses";
import { clearReceipts } from "../../redux/receipts";
const Navbar = ({
  openCart,
  toggleCart,
  checkOutEvent,
  emptyCart,
  items,
  changeQuantity,
  printReceipt,
  setPrintReceipt,
  removeItemFromCart,
  increaseCartItemQuantity,
  decreaseCartItemQuantity,
}) => {
  const handleRefresh = useRefresh();
  const storeId = localStorage.getItem("storeId");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(false);
  const toggle = () => {
    setShowMenu(!showMenu);
  };
  const handleLogout = () => {
    dispatch(clearItems());
    dispatch(clearSales());
    dispatch(resetCart());
    dispatch(clearExpenses());
    dispatch(clearReceipts());
    dispatch(Logout());
    persistor.purge().then(() => {
      navigate("/login");
    });
  };

  return (
    <>
      <CheckOutDialog
        open={openCart}
        toggleCart={toggleCart}
        checkOutEvent={checkOutEvent}
        emptyCart={emptyCart}
        items={items}
        changeQuantity={changeQuantity}
        printReceipt={printReceipt}
        setPrintReceipt={setPrintReceipt}
        removeItemFromCart={removeItemFromCart}
        increaseCartItemQuantity={increaseCartItemQuantity}
        decreaseCartItemQuantity={decreaseCartItemQuantity}
      />
      <div className="navbar-container">
        <div className="nav-left">
          <Link to="/">
            <Tooltip title="Back to Dashboard">
              <h1 className="logo refresh">
                <DashboardCustomize /> StoreSync
              </h1>
            </Tooltip>
          </Link>
          <Tooltip title="Reload Store Data">
            <li
              className="refresh"
              key={0}
              onClick={() => handleRefresh(storeId)}
            >
              <Autorenew />
            </li>
          </Tooltip>
        </div>
        <div className="nav-right">
          <div className="menu-list">
            <div className="shopping-cart-container" onClick={toggleCart}>
              <Tooltip title="View Cart">
                <AddShoppingCartOutlined className="cart-icon" />
              </Tooltip>
              <div className="cart-items-number-container">
                <span className="cart-items-number">{items?.length}</span>
              </div>
            </div>
          </div>
          <div className={showMenu ? "menu-list-mb" : "no-show-menu"}>
            <div className="menu-items">
              <Link to="/items">
                <li key={5} className="menu-item-mb">
                  <InventoryOutlined /> Items
                </li>
              </Link>
              <Link to="/sales">
                <li key={6} className="menu-item-mb">
                  <TrendingUp /> Sales
                </li>
              </Link>

              <Link to="/highlights" className="menu-item-mb">
                <PlayCircleOutline /> Monthly Highlights
              </Link>
              <Link to="/invoices" className="menu-item-mb">
                <ReceiptOutlined /> Supplier Invoices
              </Link>
              <Link to="/expenses" className="menu-item-mb">
                <ShoppingCartCheckout /> Expenses
              </Link>
              <Link to="/credit" className="menu-item-mb">
                <AddCardOutlined /> Credit
              </Link>
              <Link to="/attendants" className="menu-item-mb">
                <PersonAddAltOutlined /> Attendants
              </Link>
              <Link to="/customers" className="menu-item-mb">
                <GroupsOutlined /> Customers
              </Link>

              <Link to="/upload_data" className="menu-item-mb">
                <ImportExport /> Import/Export Data
              </Link>
              {/* ))} */}

              <li
                className="menu-item-mb
            "
                onClick={() => handleLogout()}
                key={4}
              >
                <LogoutSharp className="ml5" /> Sign out
              </li>
            </div>
          </div>
          {!showMenu && (
            <Tooltip title="Open Menu">
              <Menu className="toggler" onClick={() => toggle()} />
            </Tooltip>
          )}
          {showMenu && (
            <Tooltip title="Close Menu">
              <Close className="toggler" onClick={() => toggle()} />
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
};
export default Navbar;
